<script setup lang="ts">
import type { Props } from './types';

defineProps<Props>();
</script>

<template>
	<span
		class="top-hint"
		data-top-icon=""
		:title="hint"
	></span>
</template>

<style>
.top-hint {
	--top-icon-size: 16px;
	--top-icon-width: var(--top-icon-size);

	cursor: default;
	border-radius: 50%;
	background: inherit;
	padding: 1px;
	color: var(--color-text-3);
	line-height: 1;
	z-index: 1;
	pointer-events: all;
}

.top-hint:hover {
	color: var(--color-text-2);
}
</style>
